<template>
  <div id="video"></div>
</template>

<script>
export default {
  props: ["url"],
  data: () => {
    return {
      currentTraceTime: 0,
    };
  },
  methods: {
    renderJwplayer(url) {
      const mockUrl = [
        {
          image: "",
          file: "http://cdn-vod.nerdof.com/hls/60545365f243c114b2b9d02d.mp4/index.m3u8",
        },
        {
          image: "",
          file: "http://cdn-vod.nerdof.com/hls/60545365f243c114b2b9d02d_1.mp4/index.m3u8",
        },
      ];
      window.jwplayer("video").setup({
        // sources: url,
        playlist: url,
        playbackRateControls: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2],
      });
    },
  },
  mounted() {
    this.renderJwplayer(this.url);
  },
  watch: {
    url(newUrl) {
      this.renderJwplayer(newUrl);
    },
  },
};
</script>